/* ============
 * Open Door Page
 * ============
 *
 *
 */

import mixin from '../../../mixins/mixin';
import rentalService from './../../../services/rental';

export default {
  data() {
    return {
      loading: false,
      returnMessage: '',
      hash: '',
      action: '',
    };
  },

  components: {
    VLoading: require('components/loading/loading.vue'),
  },

  mixins: [mixin],

  async mounted() {
    const vm = this;

    if (vm.$route.params.hash) {
      vm.hash = vm.$route.params.hash;
    }
  },

  methods: {
    async openOrCloseDoor(action) {
      const vm = this;
      vm.loading = true;
      vm.action = action;
      await rentalService.openOrCloseRentalDoor(vm, action, vm.hash);
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/rentals/open-or-close-rental-door/open-or-close-rental-door.js